import GoldStockActionTypes from './gold-stock-report.types';

/** ***************** GET GOLD STOCK REPORT START *********************** */
export const getGoldStockReportStart = (getData: any) => ({
	type: GoldStockActionTypes.GET_GOLD_STOCK_REPORT_START,
	payload: getData,
});

export const getGoldStockReportSuccess = (successData: any) => ({
	type: GoldStockActionTypes.GET_GOLD_STOCK_REPORT_SUCCESS,
	payload: successData,
});

export const getGoldStockReportFailure = (failureData: any) => ({
	type: GoldStockActionTypes.GET_GOLD_STOCK_REPORT_FAILURE,
	payload: failureData,
});

export const getGoldStockReportResponseResetStart = () => ({
	type: GoldStockActionTypes.GET_GOLD_STOCK_REPORT_RESPONSE_RESET,
});

export const getGoldStockReportResponseChanged = () => ({
	type: GoldStockActionTypes.GET_GOLD_STOCK_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET GOLD STOCK REPORT END *********************** */
